import React from 'react';

/**
 * PageHeader component for consistent page title + subtitle layout
 * @param {object} props
 * @param {string} props.title - Page title
 * @param {string} props.subtitle - Page subtitle/description
 * @param {React.ReactNode} props.badge - Optional badge or tag
 * @param {React.ReactNode} props.action - Optional action button/element
 * @param {string} props.className - Additional CSS classes
 */
export default function PageHeader({ title, subtitle, badge, action, className = '' }) {
  return (
    <div className={`mb-8 ${className}`}>
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-2">
            <h1 className="text-3xl md:text-4xl font-serif font-bold text-neutral-900">{title}</h1>
            {badge && <div>{badge}</div>}
          </div>
          {subtitle && <p className="text-neutral-600">{subtitle}</p>}
        </div>
        {action && <div className="flex-shrink-0">{action}</div>}
      </div>
    </div>
  );
}
